import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CheckboxChangeEvent } from 'primeng/checkbox';
import { SharedModule } from '@/app/shared/shared.module';
import { NoteTagsLookupModel, NoteViewModel } from '@/app/proxy/proxies';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

export interface NoteFilterResponse {
  year?: string;
  labels?: string[];
  noLabel?: boolean;
  photosAttached?: boolean;
  photosNotAttached?: boolean;
  descriptionAdded?: boolean;
  descriptionNotAdded?: boolean;
}

@Component({
  selector: 'app-crop-health-note-all-filter-modal',
  imports: [SharedModule],
  templateUrl: './crop-health-note-all-filter-modal.component.html',
  styleUrl: './crop-health-note-all-filter-modal.component.less',
})
export class CropHealthNoteAllFilterModalComponent implements OnInit, OnChanges {
  @Input() notes: NoteViewModel[] = [];
  @Input() noteTags: NoteTagsLookupModel[] = [];
  @Input() filterParameters: NoteFilterResponse;

  yearOptions: string[] = [];
  selectedYear: string;

  selectedLabels: string[] = [];
  noLabel: boolean;
  photosAttached: boolean;
  photosNotAttached: boolean;

  descriptionAdded: boolean;
  descriptionNotAdded: boolean;

  allLabelsSelected: boolean;

  constructor(private dialogRef: DynamicDialogRef) {}

  ngOnInit(): void {
    if (this.filterParameters) {
      this.selectedYear = this.filterParameters.year;
      this.selectedLabels = this.filterParameters.labels ?? [];
      this.allLabelsSelected = this.selectedLabels ? this.selectedLabels.length === this.noteTags.length : false;
      this.noLabel = this.filterParameters.noLabel;
      this.photosAttached = this.filterParameters.photosAttached;
      this.photosNotAttached = this.filterParameters.photosNotAttached;
      this.descriptionAdded = this.filterParameters.descriptionAdded;
      this.descriptionNotAdded = this.filterParameters.descriptionNotAdded;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['notes'] && this.notes?.length > 0) {
      this.yearOptions = [];

      for (const note of this.notes) {
        const year = note.createdAt.toFormat('yyyy');
        if (!this.yearOptions.find((e) => e === year)) {
          this.yearOptions.push(year);
        }
      }
      this.yearOptions = this.yearOptions.sort((a, b) => +b - +a);
    }
  }

  onSelectAllLabels(event: CheckboxChangeEvent) {
    this.allLabelsSelected = event.checked;
    if (this.allLabelsSelected) {
      this.noLabel = false;
      this.selectedLabels = this.noteTags.map((e) => e.value);
    } else {
      this.selectedLabels = [];
    }
  }

  onSelectNoLabel(event: CheckboxChangeEvent) {
    this.noLabel = event.checked;
    if (this.noLabel) {
      this.allLabelsSelected = false;
      this.selectedLabels = [];
    }
  }

  onSelectLabel(event: CheckboxChangeEvent, label: string) {
    if (event.checked) {
      this.selectedLabels.push(label);
    } else {
      this.selectedLabels = this.selectedLabels.filter((e) => e !== label);
    }

    this.allLabelsSelected = this.selectedLabels.length === this.noteTags.length;
  }

  onSelectPhotoAttached(event: CheckboxChangeEvent) {
    this.photosAttached = event.checked;
    if (this.photosAttached) {
      this.photosNotAttached = false;
    }
  }
  onSelectPhotoNotAttached(event: CheckboxChangeEvent) {
    this.photosNotAttached = event.checked;
    if (this.photosNotAttached) {
      this.photosAttached = false;
    }
  }

  onSelectDescriptionAdded(event: CheckboxChangeEvent) {
    this.descriptionAdded = event.checked;
    if (this.descriptionAdded) {
      this.descriptionNotAdded = false;
    }
  }
  onSelectDescriptionNotAdded(event: CheckboxChangeEvent) {
    this.descriptionNotAdded = event.checked;
    if (this.descriptionNotAdded) {
      this.descriptionAdded = false;
    }
  }

  apply() {
    const modalResponse: NoteFilterResponse = {
      year: this.selectedYear,
      labels: this.selectedLabels?.length > 0 ? this.selectedLabels : null,
      noLabel: this.noLabel,
      photosAttached: this.photosAttached,
      photosNotAttached: this.photosNotAttached,
      descriptionAdded: this.descriptionAdded,
      descriptionNotAdded: this.descriptionNotAdded,
    };

    this.dialogRef.close(modalResponse);
  }

  resetFilters() {
    this.selectedYear = null;
    this.selectedLabels = [];
    this.photosAttached = null;
    this.photosNotAttached = null;
    this.descriptionAdded = null;
    this.descriptionNotAdded = null;
  }

  isLabelSelected(label: string) {
    return this.selectedLabels?.some((e) => e === label);
  }
}
